import { Table } from 'antd';
import React from 'react'

const LineTable2 = () => {
     const columns = [
        {
            title: 'Reason',
            dataIndex: 'Reason',
            key: 'Reason',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Count',
            dataIndex: 'Count',
            key: 'Count',
        },
        {
            title: 'Minutes Lost',
            dataIndex: 'MiniLost',
            key: 'MiniLost',
        },
   
        
      
    ];
    const data = [
  {
    key: '1',
    Reason: 'Lunch / Dinner',
    Count: 2,
    MiniLost: 30,
  
  },
  {
    key: '2',
    Reason:'Breakdown Electrical',
    Count: 1,
    MiniLost: 23,
  },
  {
    key: '3',
    Reason: 'Electrical shutdown',
    Count: 2,
    MiniLost: 44,
  },
  {
    key: '4',
    Reason: 'Breakdown Mechanical',
    Count: 1,
    MiniLost: 20,
  },
  {
    key: '5',
    Reason: 'Lunch / Dinner',
    Count: 1,
    MiniLost: 20,
  },
  {
    key: '6',
    Reason: 'Breakdown Electrical',
    Count: 4,
    MiniLost: 30,
  },
  

];
  return (
    <div>
            <Table columns={columns} dataSource={data}  pagination={false} />
    </div>
  )
}

export default LineTable2